

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".header__inline-menu details").forEach((item) => {
    let timeout;

    item.addEventListener("mouseenter", () => {
      clearTimeout(timeout);
      item.setAttribute("open", true);
    });

    item.addEventListener("mouseleave", () => {
      timeout = setTimeout(() => {
        item.removeAttribute("open");
      }, 200); // little delay here to keep the menu alive during the choice :)
    });
  });

  const columnIndex = 1;
  const cells = document.querySelectorAll(
    `table td:nth-child(${columnIndex + 1}), table th:nth-child(${
      columnIndex + 1
    })`
  );

  cells.forEach((cell) => {
    cell.addEventListener("mouseenter", () => {
      cells.forEach((c) => c.classList.add("hovered"));
    });
    cell.addEventListener("mouseleave", () => {
      cells.forEach((c) => c.classList.remove("hovered"));
    });
  });

  var prevArrow =
    '<button class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 511.641 511.641" xml:space="preserve" class=""><g><path d="M148.32 255.76 386.08 18c4.053-4.267 3.947-10.987-.213-15.04a10.763 10.763 0 0 0-14.827 0L125.707 248.293a10.623 10.623 0 0 0 0 15.04L371.04 508.667c4.267 4.053 10.987 3.947 15.04-.213a10.763 10.763 0 0 0 0-14.827L148.32 255.76z" fill="#ee1e24" opacity="1" data-original="#000000" class=""></path></g></svg></button>';

  var nextArrow =
    '<button class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 511.949 511.949" xml:space="preserve" class=""><g><path d="M386.235 248.308 140.902 2.975c-4.267-4.053-10.987-3.947-15.04.213a10.763 10.763 0 0 0 0 14.827l237.76 237.76-237.76 237.867c-4.267 4.053-4.373 10.88-.213 15.04 4.053 4.267 10.88 4.373 15.04.213l.213-.213 245.333-245.333a10.624 10.624 0 0 0 0-15.041z" fill="#ee1e24" opacity="1" data-original="#000000"></path></g></svg></button>';

  jQuery(".porduct-list-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: false,
    speed: 300,
    slidesToShow: 4,
    adaptiveHeight: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

 
   // Function to handle play/pause functionality on the current active slide
  function handleActiveSlide() {
    // Target only the active slides 
    $('.slick-active').each(function() {
      const $slide = $(this);
      const $video = $slide.find('.testimonial-video');

      if ($video.length) {
        const $container = $video.closest('.testimonial-video-container');
        
        // Unbind previous event handlers to prevent duplication
        $container.find('.play-pause-button').off('click').on('click', function() {
          if ($video.prop('paused')) {
            $video.get(0).play();
          } else {
            $video.get(0).pause();
          }
        });

        $video.off('play pause').on('play', function() {
          $container.addClass('is-playing');
        }).on('pause', function() {
          $container.removeClass('is-playing');
        });
      }
    });
  }

  // Call this function on initial load and when slides change
  $('.testimonial-slider').on('init afterChange', function() {
    handleActiveSlide();
  });

   jQuery(".testimonial-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: false,
    speed: 300,
    slidesToShow: 3,
    adaptiveHeight: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });


  // Ensure videos are paused before slide changes
  $('.testimonial-slider').on('beforeChange', function(event, slick, currentSlide) {
    // Pause videos of the current active slides
    $('.slick-active').each(function() {
      const $video = $(this).find('.testimonial-video');
      if ($video.length && !$video.prop('paused')) {
        $video.get(0).pause();
      }
    });
  });

  // Manually trigger the init event on page load to bind events on initial slides
  $('.testimonial-slider').slick('setPosition');

  

  /* Blog Table of content Start */
  if ($(".sidebar-table-of-content").length) {
    const $toc = $("#toc-list"),
      $heads = $(".article-template__content").find("h2, h3");

    const tocItems = [];

    // Build TOC with nested subheadings
    let currentH2 = null;
    $heads.each((i, el) => {
      const $el = $(el),
        tag = el.tagName.toLowerCase(),
        id = "toc-heading-" + i;
      $el.attr("id", id);

      if (tag === "h2") {
        const $li = $("<li>").addClass("toc-heading");
        const $link = $("<a>")
          .attr("href", "#" + id)
          .text($el.text());
        $li.append($link).append('<ul class="toc-sublist"></ul>');
        $toc.append($li);
        currentH2 = $li;
        tocItems.push({ id, type: "h2", el });
      } else if (tag === "h3" && currentH2) {
        const $subLi = $("<li>").addClass("toc-subheading");
        const $link = $("<a>")
          .attr("href", "#" + id)
          .text($el.text());
        $subLi.append($link);
        currentH2.find(".toc-sublist").append($subLi);
        tocItems.push({ id, type: "h3", el });
      }
    });

    // Initially hide all sublists
    $(".toc-sublist").hide();

    // Scroll to anchor smoothly
    $toc.on("click", "a", function (e) {
      e.preventDefault();
      const target = $($(this).attr("href"));
      if (target.length) {
        $("html, body")
          .stop()
          .animate({ scrollTop: target.offset().top - 80 }, 400);
      }
    });

    // Active state + sublist toggle based on scroll
    const updateActive = () => {
      const scroll = $(window).scrollTop() + 100;
      let activeId = "";
      tocItems.forEach((item) => {
        if (scroll >= $(item.el).offset().top) {
          activeId = item.id;
        }
      });

      // Highlight active TOC item
      $toc.find("a").removeClass("active");
      if (activeId) {
        const $activeLink = $toc.find(`a[href="#${activeId}"]`);
        $activeLink.addClass("active");

        // Show/hide sublist logic
        if ($activeLink.closest(".toc-heading").length) {
          $(".toc-sublist").hide();
          $activeLink.closest(".toc-heading").find(".toc-sublist").show();
        }
      }
    };

    updateActive();
    $(window).on("scroll", updateActive);
  }
});

// FAQ CSS
let questionButton = document.querySelectorAll(".question button");

questionButton.forEach((elem) => {
  elem.addEventListener("click", () => {
    elem.classList.toggle("show");
  });
});
